import React from 'react';

const FinalCta = () => {
  return (
    <section id="download" className="py-24 bg-white" data-testid="final-cta">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mb-6">
          <span className="gradient-text">Build with Confidence.</span>
        </h2>
        
        <p className="text-xl text-gray-500 mb-10">
          Download free on iOS and Android.
        </p>
        
        {/* App store buttons - visually matched sizes */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-2">
          <a 
            href="https://apps.apple.com/au/app/buildpilot/id6477372083"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-appstore-btn"
            className="flex items-center h-[54px]"
          >
            <img 
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83" 
              alt="Download on the App Store" 
              className="h-[54px] w-auto"
            />
          </a>
          
          <a 
            href="https://play.google.com/store/apps/details?id=com.buildpilot.android&hl=en_US"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-playstore-btn"
            className="flex items-center h-[54px]"
          >
            <img 
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
              alt="Get BuildPilot App on Google Play Store for Android devices" 
              className="h-[78px] w-auto"
              style={{ marginTop: '-12px', marginBottom: '-12px', marginLeft: '-12px', marginRight: '-12px' }}
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
